// extracted by mini-css-extract-plugin
export var rodape = "styles-module--rodape--2y6U8";
export var people = "styles-module--people--1KGzg";
export var overlay = "styles-module--overlay--1UUhd";